/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class IndexValueIterator<T> implements IterableIterator<[number, T]> {

  private index: number = -1;

  constructor(private originalIterator: Iterator<T>) { }

  next(): IteratorResult<[number, T]> {
    const originalResult = this.originalIterator.next();
    if (originalResult.done) {
      return { done: true, value: undefined };
    }
    this.index++;
    return { done: false, value: [this.index, originalResult.value] };
  }

  [Symbol.iterator](): IterableIterator<[number, T]> {
    return this;
  }
}
